import { render, staticRenderFns } from "./WoTermCategory.vue?vue&type=template&id=42aea241&"
import script from "./WoTermCategory.vue?vue&type=script&lang=js&"
export * from "./WoTermCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports